// SiteUp M9 — agrupa o anúncio de álbum com as mídias que chegam depois.
//
// O WAHA manda o anúncio como texto e cada foto/vídeo como mensagem
// seguinte. O backend grava content_attributes.album no anúncio; o fio
// esconde as mídias individuais e a bolha desenha a grade.

const ALBUM_HEADER =
  /^\s*📷\s*\*{0,2}\s*(Mensagem\s+de\s+Álbum\s+Recebida|Album\s+Message\s+Received)\b/i;
const WAHA_PREFIX = /^\s*\*📱 Enviado (do WhatsApp|via API)\*\s*/;
const MEDIA_TYPES = new Set(['image', 'video', 'ig_reel']);

const stripPrefix = content =>
  String(content || '')
    .replace(WAHA_PREFIX, '')
    .trim();

export const isAlbumAnnouncement = message => {
  if (!message) return false;
  const attrs = message.contentAttributes || message.content_attributes || {};
  if (attrs.album) return true;
  return ALBUM_HEADER.test(stripPrefix(message.content));
};

export const albumCounts = message => {
  const attrs = message?.contentAttributes || message?.content_attributes || {};
  const structured = attrs.album;
  if (structured) {
    return {
      imageCount: Number(structured.imageCount ?? structured.image_count ?? 0),
      videoCount: Number(structured.videoCount ?? structured.video_count ?? 0),
      totalCount: Number(structured.totalCount ?? structured.total_count ?? 0),
    };
  }

  const body = stripPrefix(message?.content);
  const total = body.match(/(?:álbum\s+com|album\s+with)\s+\*{0,2}(\d+)/i);
  const images = body.match(/(?:Imagens|Images)\s*:\s*\*{0,2}\s*(\d+)/i);
  const videos = body.match(/(?:Vídeos|Videos)\s*:\s*\*{0,2}\s*(\d+)/i);
  const imageCount = images ? Number(images[1]) : 0;
  const videoCount = videos ? Number(videos[1]) : 0;
  return {
    imageCount,
    videoCount,
    totalCount: total ? Number(total[1]) : imageCount + videoCount,
  };
};

const senderKey = message =>
  message?.senderId ?? message?.sender?.id ?? message?.sender_id ?? null;

export const isAlbumMedia = message => {
  const attachments = message?.attachments || [];
  if (!attachments.length) return false;
  return attachments.every(item => {
    const type = item.fileType || item.file_type;
    return MEDIA_TYPES.has(type);
  });
};

export const collectAlbumMembers = (messages, index) => {
  const announcement = messages[index];
  if (!isAlbumAnnouncement(announcement)) return [];

  const expected = albumCounts(announcement).totalCount;
  const sender = senderKey(announcement);
  const members = [];

  for (let i = index + 1; i < messages.length; i += 1) {
    const candidate = messages[i];
    if (senderKey(candidate) !== sender) break;
    if (!isAlbumMedia(candidate)) break;
    members.push(candidate);
    if (expected > 0 && members.length >= expected) break;
    if (members.length >= 20) break;
  }

  return members;
};

export const hiddenAlbumMemberIds = messages => {
  const hidden = new Set();
  messages.forEach((message, index) => {
    if (!isAlbumAnnouncement(message)) return;
    collectAlbumMembers(messages, index).forEach(member =>
      hidden.add(member.id)
    );
  });
  return hidden;
};

export const albumAttachmentsFor = (message, messages) => {
  const index = messages.findIndex(item => item.id === message.id);
  if (index < 0) return [];
  return collectAlbumMembers(messages, index).flatMap(
    member => member.attachments || []
  );
};
